import { Box, Typography } from '@mui/material';
import { insufficientXpCrossSrc, xpCoinSrc } from '../../assets/bazzar';
import { BazaarBackLink, BazaarDialogShell, BazaarRibbonTitle } from './bazaarDialogShared';

/** Figma 10040:6782 — insufficient XP error popup */
const DIALOG_MIN_HEIGHT = 341;

function InsufficientXpIllustration() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 70.313,
        height: 75,
        mx: 'auto',
        mt: 2.5,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: '100px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src={xpCoinSrc}
          alt=""
          sx={{
            position: 'absolute',
            width: '186.18%',
            height: '116.36%',
            maxWidth: 'none',
            left: '-43.94%',
            top: '-7.05%',
          }}
        />
      </Box>
      <Box
        component="img"
        src={insufficientXpCrossSrc}
        alt=""
        sx={{
          position: 'absolute',
          right: -4,
          bottom: -2,
          width: 28,
          height: 28,
          display: 'block',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
}

export default function MartInsufficientXpDialog({ open, onClose }) {
  return (
    <BazaarDialogShell open={open} onClose={onClose} minHeight={DIALOG_MIN_HEIGHT}>
      <BazaarRibbonTitle tone="error" ribbonVariant="error">
        Not Enough XPs!
      </BazaarRibbonTitle>

      <InsufficientXpIllustration />

      <Typography
        sx={{
          mt: 2.2,
          color: '#fff',
          fontWeight: 600,
          fontSize: 16,
          lineHeight: '24px',
          letterSpacing: '0.8px',
          textAlign: 'center',
          maxWidth: 306,
          mx: 'auto',
        }}
      >
        You don&apos;t have enough XPs to redeem this coupon.
      </Typography>

      <BazaarBackLink onClick={onClose} />
    </BazaarDialogShell>
  );
}
